import { Directive, ElementRef, Self } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Directive({
  selector: 'mat-icon[convert]:not([svgIcon]):not([fontIcon])',
})
export class MatIconFontToSvgDirective {
  constructor(private elementRef: ElementRef, @Self() private matIcon: MatIcon) {}

  convertIcons(): void {
    const contentText = this.elementRef.nativeElement?.innerText?.trim();
    if (!contentText) return;
    const svgIcon = MAT_ICON_LIGATURE_TO_SVG[this.elementRef.nativeElement?.innerText?.trim()];
    if (!!svgIcon) {
      this.matIcon.svgIcon = svgIcon;
      this.elementRef.nativeElement.innerText = null;
    } else {
      console.error(`Missing icon: ${contentText}`);
    }
  }

  ngOnInit(): void {
    this.convertIcons();
  }

  ngAfterViewInit(): void {
    this.convertIcons();
  }
}

export const MAT_ICON_LIGATURE_TO_SVG: Record<string, string> = {
  '3d_rotation': 'rotate-3d',
  '4k': 'video-4k-box',
  'ac_unit': 'snowflake',
  'access_alarms': 'alarm',
  'access_time': 'clock-outline',
  'accessibility': 'human',
  'accessible': 'wheelchair-accessibility',
  'account_balance': 'bank',
  'account_balance_wallet': 'wallet',
  'account_box': 'account-box',
  'account_circle': 'account-circle',
  'adb': 'android-debug-bridge',
  'add': 'plus',
  'add_alarm': 'alarm-plus',
  'add_alert': 'bell-plus',
  'add_box': 'plus-box',
  'add_call': 'phone-plus',
  'add_circle': 'plus-circle',
  'add_circle_outline': 'plus-circle-outline',
  'add_location': 'map-marker-plus',
  'add_shopping_cart': 'cart-plus',
  'add_to_photos': 'plus-box-multiple',
  'adjust': 'adjust',
  'agriculture': 'tractor-variant',
  'airline_seat_flat': 'seat-flat',
  'airline_seat_flat_angled': 'seat-flat-angled',
  'airline_seat_individual_suite': 'seat-individual-suite',
  'airline_seat_legroom_extra': 'seat-legroom-extra',
  'airline_seat_legroom_normal': 'seat-legroom-normal',
  'airline_seat_legroom_reduced': 'seat-legroom-reduced',
  'airline_seat_recline_extra': 'seat-recline-extra',
  'airline_seat_recline_normal': 'seat-recline-normal',
  'airplanemode_active': 'airplane',
  'airplanemode_inactive': 'airplane-off',
  'alarm': 'alarm',
  'alarm_add': 'alarm-plus',
  'alarm_off': 'alarm-off',
  'alarm_on': 'alarm-check',
  'album': 'album',
  'align_horizontal_center': 'align-horizontal-center',
  'align_horizontal_left': 'align-horizontal-left',
  'align_horizontal_right': 'align-horizontal-right',
  'align_vertical_bottom': 'align-vertical-bottom',
  'align_vertical_center': 'align-vertical-center',
  'align_vertical_top': 'align-vertical-top',
  'all_inclusive': 'all-inclusive',
  'alternate_email': 'at',
  'anchor': 'anchor',
  'android': 'android',
  'animation': 'transition',
  'announcement': 'message-alert',
  'api': 'api',
  'approval': 'stamper',
  'apps': 'apps',
  'architecture': 'math-compass',
  'archive': 'package-down',
  'arrow_back': 'arrow-left',
  'arrow_downward': 'arrow-down',
  'arrow_drop_down': 'menu-down',
  'arrow_drop_down_circle': 'arrow-down-drop-circle',
  'arrow_drop_up': 'menu-up',
  'arrow_forward': 'arrow-right',
  'arrow_left': 'menu-left',
  'arrow_right': 'menu-right',
  'arrow_upward': 'arrow-up',
  'aspect_ratio': 'aspect-ratio',
  'assessment': 'poll-box',
  'assignment': 'clipboard-text',
  'assignment_ind': 'clipboard-account',
  'assignment_late': 'clipboard-alert',
  'assignment_return': 'clipboard-arrow-left',
  'assignment_returned': 'clipboard-arrow-down',
  'assignment_turned_in': 'clipboard-check',
  'assistant': 'assistant',
  'assistant_photo': 'flag',
  'atm': 'atm',
  'attach_file': 'paperclip',
  'attach_money': 'currency-usd',
  'attachment': 'attachment',
  'auto_awesome': 'creation',
  'auto_awesome_mosaic': 'collage',
  'auto_awesome_motion': 'animation',
  'auto_fix_high': 'auto-fix',
  'auto_stories': 'book-open-page-variant',
  'autorenew': 'autorenew',
  'av_timer': 'av-timer',
  'backpack': 'bag-personal',
  'backspace': 'backspace',
  'backup': 'cloud-upload',
  'badge': 'badge-account-horizontal',
  'ballot': 'ballot',
  'bar_chart': 'poll',
  'battery_alert': 'battery-alert',
  'battery_charging_full': 'battery-charging',
  'battery_full': 'battery',
  'battery_std': 'battery',
  'battery_unknown': 'battery-unknown',
  'beenhere': 'marker-check',
  'block': 'cancel',
  'bluetooth': 'bluetooth',
  'bluetooth_audio': 'bluetooth-audio',
  'bluetooth_connected': 'bluetooth-connect',
  'bluetooth_disabled': 'bluetooth-off',
  'bluetooth_searching': 'bluetooth-audio',
  'blur_circular': 'blur-radial',
  'blur_linear': 'blur-linear',
  'blur_off': 'blur-off',
  'blur_on': 'blur',
  'bolt': 'flash',
  'book': 'book',
  'bookmark': 'bookmark',
  'bookmark_border': 'bookmark-outline',
  'bookmark_outline': 'bookmark-outline',
  'border_all': 'border-all',
  'border_bottom': 'border-bottom',
  'border_clear': 'border-none',
  'border_color': 'border-color',
  'border_horizontal': 'border-horizontal',
  'border_left': 'border-left',
  'border_outer': 'border-outside',
  'border_right': 'border-right',
  'border_style': 'border-style',
  'border_top': 'border-top',
  'border_vertical': 'border-vertical',
  'branding_watermark': 'watermark',
  'brightness_1': 'brightness-1',
  'brightness_2': 'brightness-2',
  'brightness_3': 'brightness-3',
  'brightness_4': 'brightness-4',
  'brightness_5': 'brightness-5',
  'brightness_6': 'brightness-6',
  'brightness_7': 'brightness-7',
  'brightness_auto': 'brightness-auto',
  'brightness_high': 'brightness-7',
  'brightness_low': 'brightness-5',
  'brightness_medium': 'brightness-6',
  'broken_image': 'image-broken-variant',
  'brush': 'brush',
  'bubble_chart': 'chart-bubble',
  'bug_report': 'bug',
  'build': 'wrench',
  'burst_mode': 'camera-burst',
  'bus_alert': 'bus-alert',
  'business': 'domain',
  'cached': 'cached',
  'cake': 'cake',
  'calendar_today': 'calendar-today',
  'call': 'phone',
  'call_end': 'phone-hangup',
  'call_made': 'call-made',
  'call_merge': 'call-merge',
  'call_missed': 'call-missed',
  'call_received': 'call-received',
  'call_split': 'call-split',
  'call_to_action': 'gesture-tap-button',
  'camera': 'camera-iris',
  'camera_alt': 'camera',
  'camera_enhance': 'camera-enhance',
  'camera_front': 'camera-front',
  'camera_rear': 'camera-rear',
  'camera_roll': 'film',
  'cancel': 'close-circle',
  'car_rental': 'car-key',
  'card_giftcard': 'wallet-giftcard',
  'card_membership': 'wallet-membership',
  'card_travel': 'wallet-travel',
  'casino': 'dice-5',
  'cast': 'cast',
  'cast_connected': 'cast-connected',
  'category': 'shape',
  'celebration': 'party-popper',
  'change_history': 'delta',
  'charging_station': 'cellphone-charging',
  'chat': 'message-text',
  'chat_bubble': 'message',
  'chat_bubble_outline': 'message-outline',
  'check': 'check',
  'check_box': 'checkbox-marked',
  'check_box_outline_blank': 'checkbox-blank-outline',
  'check_circle': 'check-circle',
  'check_circle_outline': 'check-circle-outline',
  'chevron_left': 'chevron-left',
  'chevron_right': 'chevron-right',
  'child_friendly': 'baby-carriage',
  'chrome_reader_mode': 'book-open',
  'circle': 'circle',
  'class': 'book-variant',
  'clear': 'close',
  'clear_all': 'notification-clear-all',
  'close': 'close',
  'closed_caption': 'closed-caption',
  'cloud': 'cloud',
  'cloud_circle': 'cloud-circle',
  'cloud_done': 'cloud-check',
  'cloud_download': 'cloud-download',
  'cloud_queue': 'cloud-outline',
  'cloud_upload': 'cloud-upload',
  'code': 'code-tags',
  'collections': 'image-multiple',
  'color_lens': 'palette',
  'colorize': 'eyedropper-variant',
  'comment': 'message-reply-text',
  'commute': 'train-car',
  'compare': 'compare',
  'compress': 'arrow-collapse-vertical',
  'computer': 'laptop',
  'confirmation_number': 'ticket-confirmation',
  'connect_without_contact': 'human-greeting-proximity',
  'construction': 'hammer-wrench',
  'contact_mail': 'card-account-mail',
  'contact_phone': 'card-account-phone',
  'contacts': 'contacts',
  'content_copy': 'content-copy',
  'content_cut': 'content-cut',
  'content_paste': 'content-paste',
  'control_point': 'plus-circle-outline',
  'control_point_duplicate': 'plus-circle-multiple-outline',
  'copyright': 'copyright',
  'create': 'pencil',
  'create_new_folder': 'folder-plus',
  'credit_card': 'credit-card-outline',
  'crop': 'crop',
  'crop_5_4': 'crop-landscape',
  'crop_free': 'crop-free',
  'crop_landscape': 'crop-landscape',
  'crop_portrait': 'crop-portrait',
  'crop_rotate': 'crop-rotate',
  'crop_square': 'crop-square',
  'dangerous': 'close-octagon',
  'data_usage': 'chart-donut',
  'date_range': 'calendar-range',
  'delete': 'delete',
  'delete_forever': 'delete-forever',
  'delete_outline': 'delete-outline',
  'delete_sweep': 'delete-sweep',
  'delivery_dining': 'moped',
  'departure_board': 'bus-clock',
  'desktop_mac': 'desktop-mac',
  'desktop_windows': 'monitor',
  'details': 'details',
  'developer_board': 'developer-board',
  'devices': 'devices',
  'dialpad': 'dialpad',
  'directions': 'directions',
  'directions_bike': 'bike',
  'directions_boat': 'ferry',
  'directions_bus': 'bus',
  'directions_car': 'car',
  'directions_ferry': 'ferry',
  'directions_railway': 'train',
  'directions_run': 'run',
  'directions_subway': 'subway-variant',
  'directions_transit': 'subway-variant',
  'directions_walk': 'walk',
  'disc_full': 'disc-alert',
  'dns': 'dns',
  'do_not_disturb': 'do-not-disturb',
  'do_not_disturb_alt': 'cancel',
  'do_not_disturb_off': 'do-not-disturb-off',
  'do_not_disturb_on': 'minus-circle',
  'domain': 'domain',
  'done': 'check',
  'done_all': 'check-all',
  'done_outline': 'check-outline',
  'drafts': 'email-open',
  'drive_eta': 'car',
  'edit': 'pencil',
  'edit_off': 'pencil-off',
  'eject': 'eject',
  'elderly': 'human-cane',
  'elevator': 'elevator-passenger',
  'email': 'email',
  'enhanced_encryption': 'lock-plus',
  'equalizer': 'equalizer',
  'error': 'alert-circle',
  'error_outline': 'alert-circle-outline',
  'escalator': 'escalator-box',
  'euro': 'currency-eur',
  'euro_symbol': 'currency-eur',
  'ev_station': 'ev-station',
  'event': 'calendar',
  'event_available': 'calendar-check',
  'event_busy': 'calendar-remove',
  'event_note': 'calendar-text',
  'event_seat': 'seat',
  'exit_to_app': 'exit-to-app',
  'expand_less': 'chevron-up',
  'expand_more': 'chevron-down',
  'explore': 'compass',
  'extension': 'puzzle',
  'face': 'face',
  'face_retouching_natural': 'face-shimmer',
  'facebook': 'facebook',
  'fast_forward': 'fast-forward',
  'fast_rewind': 'rewind',
  'favorite': 'heart',
  'favorite_border': 'heart-outline',
  'favorite_outline': 'heart-outline',
  'feedback': 'message-alert',
  'fiber_manual_record': 'record',
  'fiber_new': 'new-box',
  'file_download': 'download',
  'file_upload': 'upload',
  'filter': 'image-multiple-outline',
  'filter_1': 'numeric-1-box-multiple-outline',
  'filter_2': 'numeric-2-box-multiple-outline',
  'filter_3': 'numeric-3-box-multiple-outline',
  'filter_4': 'numeric-4-box-multiple-outline',
  'filter_5': 'numeric-5-box-multiple-outline',
  'filter_6': 'numeric-6-box-multiple-outline',
  'filter_7': 'numeric-7-box-multiple-outline',
  'filter_8': 'numeric-8-box-multiple-outline',
  'filter_9': 'numeric-9-box-multiple-outline',
  'filter_9_plus': 'numeric-9-plus-box-multiple-outline',
  'filter_b_and_w': 'image-filter-black-white',
  'filter_list': 'filter-variant',
  'find_in_page': 'file-find',
  'find_replace': 'find-replace',
  'fingerprint': 'fingerprint',
  'fire_extinguisher': 'fire-extinguisher',
  'fire_hydrant': 'fire-hydrant',
  'fireplace': 'fireplace',
  'first_page': 'page-first',
  'fitness_center': 'dumbbell',
  'flag': 'flag',
  'flare': 'flare',
  'flash_auto': 'flash-auto',
  'flash_off': 'flash-off',
  'flash_on': 'flash',
  'flight': 'airplane',
  'flight_land': 'airplane-landing',
  'flight_takeoff': 'airplane-takeoff',
  'flip_to_back': 'flip-to-back',
  'flip_to_front': 'flip-to-front',
  'folder': 'folder',
  'folder_open': 'folder-outline',
  'folder_shared': 'folder-account',
  'folder_special': 'folder-star',
  'format_align_center': 'format-align-center',
  'format_align_justify': 'format-align-justify',
  'format_align_left': 'format-align-left',
  'format_align_right': 'format-align-right',
  'format_bold': 'format-bold',
  'format_clear': 'format-clear',
  'format_color_fill': 'format-color-fill',
  'format_color_reset': 'water-off',
  'format_color_text': 'format-color-text',
  'format_indent_decrease': 'format-indent-decrease',
  'format_indent_increase': 'format-indent-increase',
  'format_italic': 'format-italic',
  'format_line_spacing': 'format-line-spacing',
  'format_list_bulleted': 'format-list-bulleted',
  'format_list_numbered': 'format-list-numbered',
  'format_list_numbered_rtl': 'format-list-numbered-rtl',
  'format_paint': 'format-paint',
  'format_size': 'format-size',
  'format_strikethrough': 'format-strikethrough',
  'format_textdirection_l_to_r': 'format-textdirection-l-to-r',
  'format_textdirection_r_to_l': 'format-textdirection-r-to-l',
  'format_underline': 'format-underline',
  'format_underlined': 'format-underline',
  'forum': 'forum',
  'forward': 'forward',
  'free_breakfast': 'coffee',
  'fullscreen': 'fullscreen',
  'fullscreen_exit': 'fullscreen-exit',
  'g_translate': 'google-translate',
  'gamepad': 'gamepad',
  'games': 'gamepad',
  'gavel': 'gavel',
  'gesture': 'gesture',
  'get_app': 'download',
  'gif': 'gif',
  'golf_course': 'golf',
  'gps_fixed': 'crosshairs-gps',
  'gps_not_fixed': 'crosshairs',
  'grade': 'star',
  'gradient': 'gradient',
  'grain': 'grain',
  'grass': 'grass',
  'grid_off': 'grid-off',
  'grid_on': 'grid',
  'group': 'account-multiple',
  'group_add': 'account-multiple-plus',
  'hail': 'hail',
  'hd': 'high-definition-box',
  'hdr_off': 'hdr-off',
  'headset': 'headset',
  'headset_mic': 'headset',
  'headset_off': 'headset-off',
  'help': 'help-circle',
  'help_outline': 'help-circle-outline',
  'high_quality': 'quality-high',
  'highlight_off': 'close-circle-outline',
  'history': 'history',
  'home': 'home',
  'hot_tub': 'hot-tub',
  'hotel': 'bed',
  'hourglass_empty': 'timer-sand-empty',
  'hourglass_full': 'timer-sand-full',
  'house': 'home',
  'how_to_reg': 'account-check',
  'how_to_vote': 'vote',
  'https': 'lock',
  'hvac': 'hvac',
  'image': 'image',
  'image_aspect_ratio': 'relative-scale',
  'image_search': 'image-search-outline',
  'import_contacts': 'book-open-blank-variant',
  'import_export': 'swap-vertical',
  'important_devices': 'monitor-cellphone-star',
  'inbox': 'inbox',
  'indeterminate_check_box': 'minus-box',
  'info_outline': 'information-outline',
  'input': 'import',
  'insert_chart': 'poll-box',
  'insert_comment': 'message-reply-text',
  'insert_drive_file': 'file',
  'insert_emoticon': 'emoticon-outline',
  'insert_invitation': 'calendar',
  'insert_link': 'link',
  'insert_photo': 'image',
  'invert_colors': 'invert-colors',
  'invert_colors_off': 'invert-colors-off',
  'ios_share': 'export-variant',
  'keyboard': 'keyboard',
  'keyboard_arrow_down': 'chevron-down',
  'keyboard_arrow_left': 'chevron-left',
  'keyboard_arrow_right': 'chevron-right',
  'keyboard_arrow_up': 'chevron-up',
  'keyboard_backspace': 'keyboard-backspace',
  'keyboard_capslock': 'keyboard-caps',
  'keyboard_hide': 'keyboard-close',
  'keyboard_return': 'keyboard-return',
  'keyboard_tab': 'keyboard-tab',
  'keyboard_voice': 'microphone',
  'kitchen': 'fridge-outline',
  'label': 'label',
  'label_off': 'label-off',
  'label_outline': 'label-outline',
  'landscape': 'image-filter-hdr',
  'language': 'web',
  'laptop': 'laptop',
  'laptop_chromebook': 'laptop-chromebook',
  'laptop_mac': 'laptop-mac',
  'laptop_windows': 'laptop-windows',
  'last_page': 'page-last',
  'launch': 'launch',
  'layers': 'layers',
  'layers_clear': 'layers-off',
  'lens': 'circle',
  'library_add': 'plus-box-multiple',
  'library_music': 'music-box-multiple',
  'lightbulb': 'lightbulb',
  'lightbulb_outline': 'lightbulb-outline',
  'link': 'link',
  'link_off': 'link-off',
  'local_activity': 'ticket',
  'local_airport': 'airplane',
  'local_atm': 'cash-usd-outline',
  'local_attraction': 'ticket',
  'local_bar': 'glass-cocktail',
  'local_cafe': 'coffee',
  'local_car_wash': 'car-wash',
  'local_convenience_store': 'store-24-hour',
  'local_dining': 'silverware',
  'local_drink': 'cup-water',
  'local_florist': 'flower',
  'local_gas_station': 'gas-station',
  'local_grocery_store': 'cart',
  'local_hospital': 'hospital-box',
  'local_laundry_service': 'washing-machine',
  'local_library': 'library',
  'local_mall': 'shopping',
  'local_movies': 'filmstrip',
  'local_offer': 'tag',
  'local_parking': 'parking',
  'local_pharmacy': 'pharmacy',
  'local_phone': 'phone',
  'local_pizza': 'pizza',
  'local_play': 'ticket',
  'local_post_office': 'email',
  'local_print_shop': 'printer',
  'local_printshop': 'printer',
  'local_restaurant': 'silverware',
  'local_see': 'camera',
  'local_shipping': 'truck',
  'local_taxi': 'taxi',
  'location_city': 'city',
  'location_off': 'map-marker-off',
  'location_on': 'map-marker',
  'location_searching': 'crosshairs',
  'lock': 'lock',
  'lock_clock': 'lock-clock',
  'lock_open': 'lock-open',
  'lock_outline': 'lock-outline',
  'login': 'login',
  'logout': 'logout',
  'looks': 'looks',
  'looks_3': 'numeric-3-box',
  'looks_4': 'numeric-4-box',
  'looks_5': 'numeric-5-box',
  'looks_6': 'numeric-6-box',
  'looks_one': 'numeric-1-box',
  'looks_two': 'numeric-2-box',
  'loop': 'refresh',
  'loupe': 'loupe',
  'low_priority': 'priority-low',
  'loyalty': 'tag-heart',
  'luggage': 'bag-checked',
  'mail': 'email',
  'mail_outline': 'email-outline',
  'map': 'map',
  'margin': 'view-grid-outline',
  'markunread': 'email',
  'memory': 'memory',
  'menu': 'menu',
  'menu_open': 'menu-open',
  'merge_type': 'call-merge',
  'message': 'message-text',
  'mic_none': 'microphone-outline',
  'mic_off': 'microphone-off',
  'microwave': 'microwave',
  'mms': 'message-image',
  'mobile_off': 'cellphone-off',
  'mode_comment': 'message-reply',
  'mode_edit': 'pencil',
  'money': 'cash-100',
  'money_off': 'currency-usd-off',
  'monitor': 'monitor',
  'mood': 'emoticon-outline',
  'moped': 'moped',
  'more': 'more',
  'more_horiz': 'dots-horizontal',
  'more_vert': 'dots-vertical',
  'motorcycle': 'motorbike',
  'mouse': 'mouse',
  'move_to_inbox': 'inbox-arrow-down',
  'movie': 'movie',
  'movie_creation': 'movie',
  'movie_filter': 'movie-filter',
  'museum': 'bank',
  'music_note': 'music-note',
  'music_off': 'music-off',
  'my_location': 'crosshairs-gps',
  'nature': 'nature',
  'nature_people': 'nature-people',
  'navigate_before': 'chevron-left',
  'navigate_next': 'chevron-right',
  'navigation': 'navigation',
  'near_me': 'near-me',
  'new_releases': 'alert-decagram',
  'nfc': 'nfc-variant',
  'note': 'note',
  'note_add': 'file-plus',
  'notes': 'text',
  'notifications': 'bell',
  'notifications_active': 'bell-ring',
  'notifications_none': 'bell-outline',
  'notifications_off': 'bell-off',
  'notifications_paused': 'bell-sleep',
  'offline_bolt': 'flash-circle',
  'opacity': 'opacity',
  'open_in_browser': 'open-in-app',
  'open_in_new': 'open-in-new',
  'pageview': 'card-search',
  'palette': 'palette',
  'panorama': 'panorama',
  'panorama_fish_eye': 'panorama-fisheye',
  'panorama_fisheye': 'panorama-fisheye',
  'panorama_horizontal': 'panorama-horizontal',
  'panorama_vertical': 'panorama-vertical',
  'panorama_wide_angle': 'panorama-wide-angle',
  'park': 'pine-tree',
  'pause': 'pause',
  'pause_circle_filled': 'pause-circle',
  'pause_circle_outline': 'pause-circle-outline',
  'payment': 'credit-card-outline',
  'people': 'account-multiple',
  'people_outline': 'account-multiple-outline',
  'perm_identity': 'account-outline',
  'perm_media': 'folder-multiple-image',
  'person': 'account',
  'person_add': 'account-plus',
  'person_outline': 'account-outline',
  'person_remove': 'account-remove',
  'person_search': 'account-search',
  'pets': 'paw',
  'phone': 'phone',
  'phone_bluetooth_speaker': 'phone-bluetooth',
  'phone_forwarded': 'phone-forward',
  'phone_in_talk': 'phone-in-talk',
  'phone_locked': 'phone-lock',
  'phone_missed': 'phone-missed',
  'phone_paused': 'phone-paused',
  'phonelink_erase': 'cellphone-erase',
  'phonelink_lock': 'cellphone-lock',
  'phonelink_off': 'cellphone-link-off',
  'phonelink_ring': 'cellphone-sound',
  'phonelink_setup': 'cellphone-cog',
  'photo_album': 'image-album',
  'photo_camera': 'camera',
  'photo_library': 'image-multiple',
  'place': 'map-marker',
  'play_arrow': 'play',
  'play_circle_filled': 'play-circle',
  'play_circle_outline': 'play-circle-outline',
  'playlist_add': 'playlist-plus',
  'playlist_add_check': 'playlist-check',
  'playlist_play': 'playlist-play',
  'plus_one': 'plus-one',
  'point_of_sale': 'point-of-sale',
  'poll': 'poll-box',
  'polymer': 'polymer',
  'pool': 'swim',
  'portrait': 'account-box-outline',
  'power': 'power-plug',
  'power_off': 'power-plug-off',
  'power_settings_new': 'power',
  'pregnant_woman': 'human-pregnant',
  'priority_high': 'exclamation-thick',
  'psychology': 'head-cog',
  'public': 'earth',
  'publish': 'publish',
  'query_builder': 'clock-outline',
  'question_answer': 'forum',
  'queue': 'plus-box-multiple',
  'queue_music': 'playlist-music',
  'radio': 'radio',
  'radio_button_checked': 'radiobox-marked',
  'radio_button_unchecked': 'radiobox-blank',
  'rate_review': 'message-draw',
  'read_more': 'page-next-outline',
  'receipt': 'receipt',
  'record_voice_over': 'account-voice',
  'redeem': 'wallet-giftcard',
  'redo': 'redo',
  'refresh': 'refresh',
  'remove': 'minus',
  'remove_circle': 'minus-circle',
  'remove_circle_outline': 'minus-circle-outline',
  'remove_red_eye': 'eye',
  'remove_shopping_cart': 'cart-off',
  'repeat': 'repeat',
  'repeat_one': 'repeat-once',
  'replay': 'replay',
  'reply': 'reply',
  'reply_all': 'reply-all',
  'report': 'alert-octagon',
  'report_problem': 'alert',
  'restaurant': 'silverware-fork-knife',
  'restaurant_menu': 'silverware',
  'restore': 'restore',
  'restore_from_trash': 'delete-restore',
  'restore_page': 'file-restore',
  'room': 'map-marker',
  'room_service': 'room-service',
  'rotate_90_degrees_ccw': 'format-rotate-90',
  'rotate_left': 'rotate-left',
  'rotate_right': 'rotate-right',
  'rounded_corner': 'rounded-corner',
  'router': 'router-wireless',
  'rowing': 'rowing',
  'rss_feed': 'rss',
  'satellite': 'satellite',
  'scanner': 'scanner',
  'scatter_plot': 'scatter-plot',
  'schedule': 'clock-outline',
  'school': 'school',
  'score': 'scoreboard',
  'screen_lock_rotation': 'screen-rotation-lock',
  'screen_rotation': 'screen-rotation',
  'sd': 'sd',
  'sd_card': 'sd',
  'sd_storage': 'sd',
  'search': 'magnify',
  'security': 'security',
  'segment': 'segment',
  'select_all': 'select-all',
  'send': 'send',
  'sentiment_very_satisfied': 'emoticon-outline',
  'settings': 'cog',
  'settings_applications': 'cog-box',
  'settings_backup_restore': 'backup-restore',
  'settings_bluetooth': 'bluetooth-settings',
  'settings_cell': 'cellphone-settings',
  'settings_input_antenna': 'video-input-antenna',
  'settings_input_component': 'video-input-component',
  'settings_input_composite': 'video-input-component',
  'settings_input_hdmi': 'video-input-hdmi',
  'settings_input_svideo': 'video-input-svideo',
  'settings_phone': 'phone-settings',
  'settings_power': 'power-settings',
  'settings_remote': 'remote',
  'settings_voice': 'microphone-settings',
  'share': 'share',
  'shield': 'shield',
  'shop': 'shopping-music',
  'shopping_basket': 'basket',
  'shopping_cart': 'cart',
  'show_chart': 'chart-line-variant',
  'shuffle': 'shuffle',
  'signal_cellular_no_sim': 'sim-off',
  'sim_card': 'sim',
  'sim_card_alert': 'sim-alert',
  'skip_next': 'skip-next',
  'skip_previous': 'skip-previous',
  'slideshow': 'play-box-outline',
  'smartphone': 'cellphone',
  'smoke_free': 'smoking-off',
  'smoking_rooms': 'smoking',
  'sms': 'message-processing',
  'sms_failed': 'message-alert',
  'sort': 'sort',
  'sort_by_alpha': 'sort-alphabetical-variant',
  'spa': 'spa',
  'speaker': 'speaker',
  'speaker_notes': 'message-bulleted',
  'speaker_notes_off': 'message-bulleted-off',
  'spellcheck': 'spellcheck',
  'stairs': 'stairs-box',
  'star': 'star',
  'star_border': 'star-outline',
  'star_half': 'star-half-full',
  'star_outline': 'star-outline',
  'star_rate': 'star',
  'stars': 'star-circle',
  'stay_current_portrait': 'cellphone',
  'stay_primary_portrait': 'cellphone',
  'stop': 'stop',
  'stop_circle': 'stop-circle',
  'storage': 'server',
  'store': 'store',
  'store_mall_directory': 'store',
  'storefront': 'storefront-outline',
  'strikethrough_s': 'format-strikethrough-variant',
  'stroller': 'baby-carriage',
  'style': 'palette-swatch',
  'subdirectory_arrow_left': 'subdirectory-arrow-left',
  'subdirectory_arrow_right': 'subdirectory-arrow-right',
  'subscriptions': 'youtube-subscription',
  'subtitles': 'subtitles',
  'subway': 'subway',
  'support': 'lifebuoy',
  'surround_sound': 'surround-sound',
  'swap_calls': 'swap-vertical-variant',
  'swap_horizontal_circle': 'swap-horizontal-circle',
  'swap_vertical_circle': 'swap-vertical-circle',
  'switch_account': 'account-box-multiple',
  'switch_camera': 'camera-switch',
  'switch_video': 'video-switch',
  'sync': 'sync',
  'sync_disabled': 'sync-off',
  'sync_problem': 'sync-alert',
  'tab': 'tab',
  'tab_unselected': 'tab-unselected',
  'tablet': 'tablet',
  'tablet_android': 'tablet-android',
  'tablet_mac': 'tablet-ipad',
  'tag': 'tag',
  'tag_faces': 'emoticon-outline',
  'terrain': 'terrain',
  'textsms': 'message-processing',
  'texture': 'texture',
  'theaters': 'filmstrip',
  'thumb_down': 'thumb-down',
  'thumb_up': 'thumb-up',
  'thumbs_up_down': 'thumbs-up-down',
  'time_to_leave': 'car',
  'timelapse': 'timelapse',
  'timeline': 'chart-timeline-variant',
  'timer': 'timer',
  'timer_10': 'timer-10',
  'timer_3': 'timer-3',
  'timer_off': 'timer-off-outline',
  'toc': 'table-of-contents',
  'toll': 'circle-multiple-outline',
  'toys': 'pinwheel',
  'track_changes': 'radar',
  'train': 'train',
  'tram': 'tram',
  'transfer_within_a_station': 'transit-transfer',
  'translate': 'translate',
  'trending_down': 'trending-down',
  'trending_flat': 'trending-neutral',
  'trending_neutral': 'trending-neutral',
  'trending_up': 'trending-up',
  'tune': 'tune',
  'turned_in': 'bookmark',
  'turned_in_not': 'bookmark-outline',
  'tv': 'television',
  'tv_off': 'television-off',
  'umbrella': 'umbrella',
  'unarchive': 'package-up',
  'undo': 'undo',
  'update': 'update',
  'usb': 'usb',
  'verified': 'check-decagram',
  'verified_user': 'shield-check',
  'vibration': 'vibrate',
  'video_call': 'video-plus',
  'videocam': 'video',
  'videocam_off': 'video-off',
  'view_agenda': 'view-agenda',
  'view_array': 'view-array',
  'view_carousel': 'view-carousel',
  'view_column': 'view-column',
  'view_comfy': 'view-comfy',
  'view_compact': 'view-compact',
  'view_day': 'view-day',
  'view_headline': 'view-headline',
  'view_in_ar': 'cube-scan',
  'view_list': 'view-list',
  'view_module': 'view-module',
  'view_quilt': 'view-quilt',
  'view_stream': 'view-stream',
  'view_week': 'view-week',
  'visibility': 'eye',
  'visibility_off': 'eye-off',
  'voice_chat': 'message-video',
  'voicemail': 'voicemail',
  'volume_mute': 'volume-low',
  'volume_off': 'volume-off',
  'vpn_key': 'key',
  'wallet_giftcard': 'wallet-giftcard',
  'wallet_membership': 'wallet-membership',
  'wallet_travel': 'wallet-travel',
  'wallpaper': 'wallpaper',
  'warning': 'alert',
  'watch': 'watch',
  'watch_later': 'clock',
  'waves': 'waves',
  'wb_auto': 'white-balance-auto',
  'wb_cloudy': 'cloud',
  'wb_incandescent': 'white-balance-incandescent',
  'wb_iridescent': 'white-balance-iridescent',
  'wb_sunny': 'white-balance-sunny',
  'wc': 'human-male-female',
  'web': 'monitor-dashboard',
  'web_asset': 'application',
  'whatshot': 'fire',
  'where_to_vote': 'map-marker-check',
  'widgets': 'widgets',
  'wifi': 'wifi',
  'wifi_lock': 'wifi-lock',
  'wifi_off': 'wifi-off',
  'work': 'briefcase',
  'work_outline': 'briefcase-outline',
  'zoom_in': 'magnify-plus-outline',
  'zoom_out': 'magnify-minus-outline',

  'analytics': 'poll-box',
  'center_focus_strong': 'image-filter-center-focus-strong',
  'center_focus_weak': 'image-filter-center-focus-weak',
  'cloud_off': 'cloud-off-outline',
  'contactless': 'contactless-payment-circle',
  'dashboard': 'view-dashboard',
  'dock': 'cellphone-dock',
  'description': 'file-document',
  'expand': 'arrow-expand-vertical',
  'filter_center_focus': 'image-filter-center-focus',
  'filter_drama': 'image-filter-drama',
  'filter_frames': 'image-filter-frames',
  'filter_hdr': 'image-filter-hdr',
  'filter_none': 'image-filter-none',
  'filter_tilt_shift': 'image-filter-tilt-shift',
  'filter_vintage': 'image-filter-vintage',
  'flip': 'flip-horizontal',
  'format_quote': 'format-quote-close',
  'hearing': 'ear-hearing',
  'highlight': 'flashlight',
  'line_style': 'format-line-style',
  'line_weight': 'format-line-weight',
  'list': 'format-list-bulleted',
  'mark_as_unread': 'email-mark-as-unread',
  'mic': 'microphone',
  'no_sim': 'sim-off',
  'party_mode': 'camera-party-mode',
  'phone_android': 'cellphone-android',
  'phone_iphone': 'cellphone-iphone',
  'phonelink': 'cellphone-link',
  'photo': 'image',
  'picture_in_picture': 'picture-in-picture-top-right',
  'picture_in_picture_alt': 'picture-in-picture-bottom-right',
  'preview': 'monitor-eye',
  'print': 'printer',
  'reorder': 'reorder-horizontal',
  'sanitizer': 'lotion-plus',
  'save': 'content-save',
  'sick': 'emoticon-sick',
  'snooze': 'alarm-snooze',
  'source': 'folder-text',
  'speed': 'speedometer',
  'sports': 'whistle',
  'stream': 'podcast',
  'subject': 'text-subject',
  'subscript': 'format-subscript',
  'swipe': 'gesture-swipe',
  'system_update': 'cellphone-arrow-down',
  'text_rotation_down': 'format-text-rotation-down',
  'text_rotation_none': 'format-text-rotation-none',
  'title': 'format-title',
  'today': 'calendar-today',
  'traffic': 'traffic-light',
  'unfold_less': 'unfold-less-horizontal',
  'unfold_more': 'unfold-more-horizontal',
  'vertical_align_bottom': 'format-vertical-align-bottom',
  'vertical_align_center': 'format-vertical-align-center',
  'vertical_align_top': 'format-vertical-align-top',
  'wash': 'hand-water',

  '5g': 'signal-5g',
  'airplay': 'apple-airplay',
  'all_out': 'circle-expand',
  'deck': 'beach',
  'north': 'arrow-up',
  'north_east': 'arrow-top-right',
  'east': 'arrow-right',
  'south_east': 'arrow-bottom-right',
  'south': 'arrow-down',
  'south_west': 'arrow-bottom-left',
  'west': 'arrow-left',
  'north_west': 'arrow-top-left',
  'forward_10': 'fast-forward-10',
  'forward_30': 'fast-forward-30',
  'forward_5': 'fast-forward-5',
  'height': 'arrow-up-down',
  'keyboard_control': 'dots-horizontal',
  'masks': 'face-mask',
  'maximize': 'window-maximize',
  'messenger': 'facebook-messenger',
  'minimize': 'window-minimize',
  'pending': 'dots-horizontal-circle',
  'rule': 'list-status',
  'superscript': 'format-superscript',
  'weekend': 'sofa',
  'work_off': 'briefcase-off',
  'access_alarm': 'alarm',
  'accessible_forward': 'wheelchair-accessibility',
  'account_tree': 'file-tree',
  'add_business': 'store-plus',
  'add_link': 'link-plus',
  'all_inbox': 'inbox-multiple',
  'assistant_direction': 'directions',
  'assistant_navigation': 'navigation',
  'attach_email': 'paperclip',
  'auto_delete': 'delete-clock',
  'auto_fix_normal': 'auto-fix',
  'baby_changing_station': 'human-baby-changing-table',
  'backup_table': 'table-multiple',
  'book_online': 'calendar-cursor',
  'calendar_view_day': 'view-day',
  'cancel_presentation': 'monitor-off',
  'cast_for_education': 'cast-education',
  'child_care': 'baby-face-outline',
  'close_fullscreen': 'arrow-collapse',
  'closed_caption_off': 'closed-caption-outline',
  'collections_bookmark': 'book-multiple',
  'comment_bank': 'comment-bookmark',
  'compare_arrows': 'compare-horizontal',
  'control_camera': 'camera-control',
  'crop_16_9': 'crop-landscape',
  'crop_din': 'crop-square',
  'crop_original': 'image-outline',
  'device_thermostat': 'thermometer',
  'devices_other': 'devices',
  'directions_train': 'train-variant',
  'dnd_forwardslash': 'cancel',
  'domain_disabled': 'domain-off',
  'drive_file_move': 'folder-move',
  'drive_file_move_outline': 'folder-move-outline',
  'drive_file_rename_outline': 'folder-edit-outline',
  'drive_folder_upload': 'folder-upload-outline',
  'electric_bike': 'bicycle-electric',
  'electric_car': 'car-electric',
  'electric_moped': 'moped-electric',
  'electric_scooter': 'scooter-electric',
  'emoji_flags': 'flag-outline',
  'emoji_nature': 'bee-flower',
  'enhance_photo_translate': 'camera-enhance',
  'exposure_minus_1': 'numeric-negative-1',
  'exposure_plus_1': 'numeric-positive-1',
  'file_copy': 'file-multiple',
  'file_download_done': 'check-underline',
  'flip_camera_android': 'orbit-variant',
  'flip_camera_ios': 'camera-flip',
  'format_shapes': 'vector-square',
  'forward_to_inbox': 'email-send-outline',
  'grid_view': 'view-grid-outline',
  'hdr_on': 'hdr',
  'home_filled': 'home-variant',
  'home_repair_service': 'toolbox',
  'home_work': 'home-city',
  'image_not_supported': 'image-off',
  'invert_colors_on': 'invert-colors',
  'king_bed': 'bed',
  'label_important': 'label-variant',
  'label_important_outline': 'label-variant-outline',
  'leak_add': 'leak',
  'leak_remove': 'leak-off',
  'leave_bags_at_home': 'bag-carry-on-off',
  'library_add_check': 'checkbox-multiple-marked',
  'library_books': 'text-box-multiple',
  'linked_camera': 'camera-wireless',
  'local_fire_department': 'fire',
  'location_pin': 'map-marker',
  'mark_email_read': 'email-check',
  'mark_email_unread': 'email-mark-as-unread',
  'menu_book': 'book-open-variant',
  'my_library_add': 'plus-box-multiple',
  'my_library_books': 'text-box-multiple',
  'my_library_music': 'music-box-multiple',
  'no_flash': 'flash-off',
  'now_wallpaper': 'wallpaper',
  'now_widgets': 'widgets',
  'offline_pin': 'check-underline-circle',
  'outdoor_grill': 'grill',
  'outlined_flag': 'flag-outline',
  'panorama_horizontal_select': 'panorama-horizontal',
  'panorama_vertical_select': 'panorama-vertical',
  'panorama_wide_angle_select': 'panorama-wide-angle',
  'perm_contact_calendar': 'calendar-account',
  'perm_device_information': 'cellphone-information',
  'perm_phone_msg': 'phone-message',
  'pest_control_rodent': 'rodent',
  'phone_callback': 'phone-return',
  'phone_disabled': 'phone-off',
  'phone_enabled': 'phone',
  'photo_camera_back': 'camera-rear-variant',
  'photo_camera_front': 'camera-front-variant',
  'pin_drop': 'pin',
  'play_circle_fill': 'play-circle',
  'post_add': 'text-box-plus-outline',
  'push_pin': 'pin',
  'qr_code_scanner': 'qrcode-scan',
  'quick_contacts_dialer': 'card-account-phone',
  'quick_contacts_mail': 'card-account-mail',
  'radio_button_off': 'radiobox-blank',
  'radio_button_on': 'radiobox-marked',
  'receipt_long': 'receipt',
  'repeat_on': 'repeat',
  'repeat_one_on': 'repeat-once',
  'replay_10': 'rewind-10',
  'replay_30': 'rewind-30',
  'replay_5': 'rewind-5',
  'schedule_send': 'send-clock',
  'screen_share': 'monitor-share',
  'settings_overscan': 'overscan',
  'shopping_bag': 'shopping',
  'short_text': 'text-short',
  'shuffle_on': 'shuffle',
  'signal_wifi_4_bar_lock': 'wifi-strength-4-lock',
  'single_bed': 'bed-single-outline',
  'speaker_group': 'speaker-multiple',
  'speaker_phone': 'cellphone-sound',
  'sports_basketball': 'basketball',
  'sports_cricket': 'cricket',
  'sports_golf': 'golf-tee',
  'sports_handball': 'handball',
  'sports_kabaddi': 'kabaddi',
  'sports_rugby': 'rugby',
  'sports_tennis': 'tennis',
  'supervisor_account': 'account-supervisor',
  'sync_alt': 'swap-horizontal',
  'tap_and_play': 'cellphone-nfc',
  'text_fields': 'format-size',
  'text_format': 'format-text-variant',
  'text_rotate_up': 'format-text-rotation-up',
  'text_rotate_vertical': 'format-text-rotation-vertical',
  'text_rotation_angledown': 'format-text-rotation-angle-down',
  'text_rotation_angleup': 'format-text-rotation-angle-up',
  'text_snippet': 'note-text',
  'thumb_down_alt': 'thumb-down',
  'thumb_down_off_alt': 'thumb-down-outline',
  'thumb_up_alt': 'thumb-up',
  'thumb_up_off_alt': 'thumb-up-outline',
  'upload_file': 'file-upload-outline',
  'video_collection': 'play-box-multiple',
  'video_library': 'play-box-multiple',
  'water_damage': 'home-flood',
  'wrap_text': 'wrap',
  'zoom_out_map': 'arrow-expand-all',
};
